import { View } from '@react-pdf/renderer';
import MissingImage from 'img/person-fresh-brain.png';
import { BrainFunctionCategory } from 'lib/utils/business/brainfunction-categories/types';
import { UseImageStoreReturn } from '../utils/create-image-store';
import { PDFSymptomCard } from './pdf-symptom-card';
import { H3 } from './pdf-default-components';

export function PDFBrainFunctionCategory(props: {
  imageStore: Pick<UseImageStoreReturn, 'getImage'>;
  brainfunctionCategory: BrainFunctionCategory;
}) {
  const options = props.brainfunctionCategory.visualisations.map(_ => ({
    title: `${_.label}`,
    gaugeImage: props.imageStore.getImage(
      [`brainfunction`, _.label, `gauge`].join('-')
    ),
    scatterImage: props.imageStore.getImage(
      [`brainfunction`, _.label, `scatter`].join('-')
    )
  }));
  const row1 = options.slice(0, 1);
  const row2 = options.slice(1);
  return (
    <View>
      <H3>{props.brainfunctionCategory.title}</H3>

      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 16,
          justifyContent: 'center'
        }}
      >
        {row1.map(option => (
          <PDFSymptomCard
            key={option.title}
            title={option.title}
            gaugeImage={option.gaugeImage ?? MissingImage}
            scatterImage={option.scatterImage ?? MissingImage}
          />
        ))}

        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            gap: 16
          }}
        >
          {row2.map(option => (
            <View
              key={option.title}
              style={{
                width: '48%',
                alignItems: 'center'
              }}
            >
              <PDFSymptomCard
                title={option.title}
                gaugeImage={option.gaugeImage ?? MissingImage}
                scatterImage={option.scatterImage ?? MissingImage}
              />
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}
